// AUTO-GENERATED - do not edit.
// Source: business/ishvaram/data/registry/customer_tools.generated.json
// Regenerate: uv run python execution/generate_customer_tools_ts.py

export type CustomerToolKind =
  | "calculator"
  | "daily_utility"
  | "generator"
  | "chat"
  | "guided_flow";

export type CustomerToolStatus = "idea" | "drafted" | "shipped" | "killed";

export interface CustomerToolSpec {
  id: string;
  brandId: string;
  name: string;
  kind: CustomerToolKind;
  status: CustomerToolStatus;
  description: string;
  sortOrder: number;
}

export const CustomerTools = {
  "free-kundali": {
    id: "free-kundali",
    brandId: "ishvaram",
    name: "Free Kundali",
    kind: "calculator",
    status: "shipped",
    description: "Generate a Vedic birth chart and its computed chart details.",
    sortOrder: 10,
  },
  "kundli-matching": {
    id: "kundli-matching",
    brandId: "ishvaram",
    name: "Kundli Matching",
    kind: "calculator",
    status: "shipped",
    description: "Compare two birth charts for Vedic compatibility.",
    sortOrder: 20,
  },
  "career-astrology": {
    id: "career-astrology",
    brandId: "ishvaram",
    name: "Career Astrology",
    kind: "calculator",
    status: "shipped",
    description: "Compute a free career-focused chart snapshot.",
    sortOrder: 30,
  },
  "prashna-kundali": {
    id: "prashna-kundali",
    brandId: "ishvaram",
    name: "Prashna Kundali",
    kind: "calculator",
    status: "shipped",
    description: "Generate a chart for a question asked at a specific moment.",
    sortOrder: 40,
  },
  numerology: {
    id: "numerology",
    brandId: "ishvaram",
    name: "Vedic Numerology",
    kind: "calculator",
    status: "shipped",
    description: "Calculate birth-date numerology values.",
    sortOrder: 50,
  },
  "name-numerology": {
    id: "name-numerology",
    brandId: "ishvaram",
    name: "Name Numerology",
    kind: "calculator",
    status: "shipped",
    description: "Calculate a numerology value from a name.",
    sortOrder: 60,
  },
  "rashi-calculator": {
    id: "rashi-calculator",
    brandId: "ishvaram",
    name: "Rashi Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Calculate the Moon-sign rashi from birth details.",
    sortOrder: 70,
  },
  "nakshatra-calculator": {
    id: "nakshatra-calculator",
    brandId: "ishvaram",
    name: "Nakshatra Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Calculate the birth nakshatra and pada.",
    sortOrder: 80,
  },
  "ascendant-calculator": {
    id: "ascendant-calculator",
    brandId: "ishvaram",
    name: "Ascendant Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Calculate the Vedic ascendant from birth details.",
    sortOrder: 90,
  },
  "dasha-calculator": {
    id: "dasha-calculator",
    brandId: "ishvaram",
    name: "Dasha Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Calculate the active Vimshottari dasha periods.",
    sortOrder: 100,
  },
  "char-dasha": {
    id: "char-dasha",
    brandId: "ishvaram",
    name: "Char Dasha",
    kind: "calculator",
    status: "shipped",
    description: "Calculate the Jaimini Char Dasha sequence.",
    sortOrder: 110,
  },
  "mangal-dosha-calculator": {
    id: "mangal-dosha-calculator",
    brandId: "ishvaram",
    name: "Mangal Dosha Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Check a birth chart for Mangal Dosha.",
    sortOrder: 120,
  },
  "kaal-sarp-dosh": {
    id: "kaal-sarp-dosh",
    brandId: "ishvaram",
    name: "Kaal Sarp Dosh Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Check a birth chart for Kaal Sarp Dosh.",
    sortOrder: 130,
  },
  "pitra-dosh-calculator": {
    id: "pitra-dosh-calculator",
    brandId: "ishvaram",
    name: "Pitra Dosh Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Check a birth chart for Pitra Dosh indicators.",
    sortOrder: 140,
  },
  "sade-sati": {
    id: "sade-sati",
    brandId: "ishvaram",
    name: "Sade Sati Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Check the current Sade Sati phase from chart data.",
    sortOrder: 150,
  },
  shadbala: {
    id: "shadbala",
    brandId: "ishvaram",
    name: "Shadbala Calculator",
    kind: "calculator",
    status: "shipped",
    description: "Calculate the six-fold strengths of the grahas.",
    sortOrder: 160,
  },
  "navamsa-chart": {
    id: "navamsa-chart",
    brandId: "ishvaram",
    name: "Navamsa Chart",
    kind: "calculator",
    status: "shipped",
    description: "Generate the D9 divisional chart.",
    sortOrder: 170,
  },
  "dasamsa-chart": {
    id: "dasamsa-chart",
    brandId: "ishvaram",
    name: "Dasamsa Chart",
    kind: "calculator",
    status: "shipped",
    description: "Generate the D10 divisional chart.",
    sortOrder: 180,
  },
  "saptamsa-chart": {
    id: "saptamsa-chart",
    brandId: "ishvaram",
    name: "Saptamsa Chart",
    kind: "calculator",
    status: "shipped",
    description: "Generate the D7 divisional chart.",
    sortOrder: 190,
  },
  "dwadasamsa-chart": {
    id: "dwadasamsa-chart",
    brandId: "ishvaram",
    name: "Dwadasamsa Chart",
    kind: "calculator",
    status: "shipped",
    description: "Generate the D12 divisional chart.",
    sortOrder: 200,
  },
  "trimsamsa-chart": {
    id: "trimsamsa-chart",
    brandId: "ishvaram",
    name: "Trimsamsa Chart",
    kind: "calculator",
    status: "shipped",
    description: "Generate the D30 divisional chart.",
    sortOrder: 210,
  },
  "shashtiamsa-chart": {
    id: "shashtiamsa-chart",
    brandId: "ishvaram",
    name: "Shashtiamsa Chart",
    kind: "calculator",
    status: "shipped",
    description: "Generate the D60 divisional chart.",
    sortOrder: 220,
  },
  "kp-astrology": {
    id: "kp-astrology",
    brandId: "ishvaram",
    name: "KP Astrology",
    kind: "calculator",
    status: "shipped",
    description: "Calculate KP astrology chart details.",
    sortOrder: 230,
  },
  "lal-kitab-kundli": {
    id: "lal-kitab-kundli",
    brandId: "ishvaram",
    name: "Lal Kitab Kundli",
    kind: "calculator",
    status: "shipped",
    description: "Generate a Lal Kitab chart view.",
    sortOrder: 240,
  },
  panchang: {
    id: "panchang",
    brandId: "ishvaram",
    name: "Panchang",
    kind: "daily_utility",
    status: "shipped",
    description: "Show location-aware daily Panchang timings.",
    sortOrder: 250,
  },
  choghadiya: {
    id: "choghadiya",
    brandId: "ishvaram",
    name: "Choghadiya",
    kind: "daily_utility",
    status: "shipped",
    description: "Show location-aware Choghadiya periods.",
    sortOrder: 260,
  },
  "rahu-kaal": {
    id: "rahu-kaal",
    brandId: "ishvaram",
    name: "Rahu Kaal",
    kind: "daily_utility",
    status: "shipped",
    description: "Show location-aware Rahu Kaal timing.",
    sortOrder: 270,
  },
  muhurat: {
    id: "muhurat",
    brandId: "ishvaram",
    name: "Muhurat",
    kind: "daily_utility",
    status: "shipped",
    description: "Find an engine-computed auspicious timing window.",
    sortOrder: 280,
  },
  "shani-transit": {
    id: "shani-transit",
    brandId: "ishvaram",
    name: "Shani Transit",
    kind: "daily_utility",
    status: "shipped",
    description: "Show the current Shani transit against chart context.",
    sortOrder: 290,
  },
  calendar: {
    id: "calendar",
    brandId: "ishvaram",
    name: "Vedic Calendar",
    kind: "daily_utility",
    status: "shipped",
    description: "Browse Vedic calendar and festival timing surfaces.",
    sortOrder: 300,
  },
  "baby-names": {
    id: "baby-names",
    brandId: "ishvaram",
    name: "Baby Names",
    kind: "generator",
    status: "shipped",
    description: "Generate name suggestions from computed birth context.",
    sortOrder: 310,
  },
  tarot: {
    id: "tarot",
    brandId: "ishvaram",
    name: "Tarot",
    kind: "generator",
    status: "shipped",
    description: "Draw a reflective tarot card or spread.",
    sortOrder: 320,
  },
  remedies: {
    id: "remedies",
    brandId: "ishvaram",
    name: "Chart Remedies",
    kind: "guided_flow",
    status: "shipped",
    description: "Generate a chart-backed remedies starting point.",
    sortOrder: 330,
  },
  "ai-astrologer": {
    id: "ai-astrologer",
    brandId: "ishvaram",
    name: "AI Astrologer",
    kind: "chat",
    status: "shipped",
    description: "Ask chart-grounded questions in an AI Jyotish conversation.",
    sortOrder: 340,
  },
} as const satisfies Record<string, CustomerToolSpec>;

export type CustomerToolId = keyof typeof CustomerTools;

export const CustomerToolAliases = {
  "ai-kundli": "free-kundali",
  "bhagyank-calculator": "numerology",
  "birth-chart": "free-kundali",
  "friends-invite-kundali": "free-kundali",
  "gun-milan": "kundli-matching",
  "kaal-sarp-dosha": "kaal-sarp-dosh",
  kundali: "free-kundali",
  "kundli-matching-detailed": "kundli-matching",
  mahadasha: "dasha-calculator",
  manglik: "mangal-dosha-calculator",
  "manglik-calculator": "mangal-dosha-calculator",
  "mulank-calculator": "numerology",
  navamsa_chart: "navamsa-chart",
  "shubh-muhurat": "muhurat",
  tarot_spread: "tarot",
  "vrat-calendar": "calendar",
} as const satisfies Record<string, CustomerToolId>;

export type CustomerToolAlias = keyof typeof CustomerToolAliases;
export type CustomerToolKey = CustomerToolId | CustomerToolAlias;

export const CustomerToolIds = Object.keys(CustomerTools) as CustomerToolId[];

export function resolveCustomerToolId(value: CustomerToolKey): CustomerToolId {
  if (Object.prototype.hasOwnProperty.call(CustomerToolAliases, value)) {
    return CustomerToolAliases[value as CustomerToolAlias];
  }
  return value as CustomerToolId;
}

export function isCustomerToolKey(value: string): value is CustomerToolKey {
  return (
    Object.prototype.hasOwnProperty.call(CustomerTools, value) ||
    Object.prototype.hasOwnProperty.call(CustomerToolAliases, value)
  );
}
